import { Button, Kind } from '@thanx/uikit/button'
import { Modal } from '@thanx/uikit/modal'
import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import { buildTranslate } from 'locales'
import React from 'react'

const t = buildTranslate('live_updates.publish_modal')

const MODAL_Z_INDEX = 1200
const CONTENT_MAX_WIDTH = '520px'

export interface PublishConfirmModalProps {
  isOpen: boolean
  // Publish mutation in flight — disables the confirm button (double-click guard).
  isPublishing: boolean
  publishTurnsOn?: boolean
  onPublish: () => void
  onKeepEditing: () => void
}

// FR-43 publish confirmation (Figma 433-1938). A dedicated dialog rather than
// the shared ConfirmModal so both buttons carry the product copy ("Keep
// editing" / "Publish changes") — ConfirmModal hard-codes its cancel label.
const PublishConfirmModal = ({
  isOpen,
  isPublishing,
  publishTurnsOn = false,
  onPublish,
  onKeepEditing,
}: PublishConfirmModalProps) => {
  const [css] = useStyletron()

  return (
    <Modal
      isOpen={isOpen}
      // Escape/backdrop dismiss must freeze the same as the buttons below —
      // otherwise it's the one escape hatch a merchant can still trigger
      // while a publish is in flight.
      onClose={isPublishing ? undefined : onKeepEditing}
      size="auto"
      closeType="small"
      zIndex={MODAL_Z_INDEX}
    >
      <div
        className={`p-xl d-flex flex-column ${css({
          maxWidth: CONTENT_MAX_WIDTH,
        })}`}
      >
        <Text.Header3 tag="h3" className="m-0">
          {t('title')}
        </Text.Header3>
        <Text.BodyText3 color="grey70" className="mt-xs">
          {publishTurnsOn ? t('body_turn_on') : t('body')}
        </Text.BodyText3>
        <div className="d-flex justify-content-end mt-l">
          <Button
            kind={Kind.SECONDARY}
            className="mr-m"
            disabled={isPublishing}
            onClick={onKeepEditing}
          >
            {t('cancel')}
          </Button>
          <Button disabled={isPublishing} onClick={onPublish}>
            {t('confirm')}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default PublishConfirmModal
